import { render, staticRenderFns } from "./IntroBody.vue?vue&type=template&id=826cac00&scoped=true&"
import script from "./IntroBody.vue?vue&type=script&lang=js&"
export * from "./IntroBody.vue?vue&type=script&lang=js&"
import style0 from "./IntroBody.vue?vue&type=style&index=0&id=826cac00&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "826cac00",
  null
  
)

export default component.exports